import { render, staticRenderFns } from "./BranchIncomeReport.vue?vue&type=template&id=c098e21e&scoped=true"
import script from "./BranchIncomeReport.vue?vue&type=script&lang=js"
export * from "./BranchIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c098e21e",
  null
  
)

export default component.exports